import React from "react";
import { Link } from "gatsby";
import styled from "styled-components";
import LinkedInIcon from "../icons/LinkedIn.svg";
import Logo from "../icons/logo.svg";
import PolicyAndCharter from "./PolicyAndCharter/PolicyAndCharter";

const StyledWrapper = styled.footer`
  background-color: var(--violet);
  color: white;

  .logo svg {
    position: relative;
    bottom: 4px;
  }

  svg path {
    fill: white;
  }

  h6 {
    font-weight: 500;
  }

  .footer-heading + .footer-heading {
    margin: 0 0 0 3rem;
  }

  span {
    font-size: 14px;
  }

  .row + .row {
    border-top: 1px solid;
  }

  .pageLinks,
  .social,
  .copyright {
    display: flex;
    justify-content: flex-end;
  }

  .social,
  .copyright {
    align-items: center;
  }

  .pageLinks {
    align-items: baseline;
  }

  .no-link {
    margin: 0 0 0 3rem;
    cursor: default;
  }

  .pageLinks,
  .social {
    justify-content: flex-end;
  }

  .copyright {
    justify-content: flex-start;
  }

  .social > a + a {
    margin: 0 0 0 2rem;
  }

  @media (max-width: 992px) {
    .logo {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .footer-heading + .footer-heading {
      margin: 1rem 0 0;
    }

    .pageLinks {
      flex-direction: column;
      justify-content: unset;
      align-items: center;
    }

    .no-link {
      margin: 1rem 0 0;
      flex-direction: column;
      justify-content: unset;
      padding-left: 0;
      align-items: center;
    }

    .social,
    .copyright {
      justify-content: center;
    }

    .social > a + a {
      margin: 0 0 0 3rem;
    }

    .row + .row {
      border-top: unset;
    }

    span {
      text-align: center;
    }
  }
`;

const Footer = () => {
  return (
    <StyledWrapper>
      <div className="container py-lg-0 py-5">
        <div className="row py-lg-4">
          <div className="col-lg-3 logo ps-lg-0 mb-lg-0 mb-5">
            <Link to="/">
              <Logo />
            </Link>
          </div>
          <div className="col-lg-9 pageLinks pe-lg-0 mb-lg-0 mb-5">
            <Link className="footer-heading" to="/team">
              <h6>Team</h6>
            </Link>
            <Link className="footer-heading" to="/careers">
              <h6>Careers</h6>
            </Link>
            <Link className="footer-heading" to="/terms-of-use">
              <h6>Terms of Use</h6>
            </Link>
            <Link className="footer-heading" to="/privacy-policy">
              <h6>Privacy Policy</h6>
            </Link>
            <div className="no-link">
              <h6>Policy and Charter</h6>
              <PolicyAndCharter />
            </div>
          </div>
        </div>
        <div className="row flex-lg-row flex-column-reverse py-lg-4">
          <div className="col-lg-9 copyright ps-lg-0">
            <span>
              © {new Date().getFullYear()} QFI Technologies Pvt Ltd. All rights
              reserved.
            </span>
          </div>
          <div className="col-lg-3 pe-lg-0 social mb-lg-0 mb-5">
            {/* <Link to='/'><FacebookIcon /></Link> */}
            <a
              rel="noreferrer noopener"
              href="https://www.linkedin.com/company/niromoney/"
            >
              <LinkedInIcon />
            </a>
          </div>
        </div>
      </div>
    </StyledWrapper>
  );
};

export default Footer;
